export default "__VITE_ASSET__4GdgHWTj__"